import React, { useContext } from "react";
import imageUpload from "assets/svgs/imageUpload.svg";
import removeImg from "assets/svgs/close.svg";
import { FormattedMessage } from "react-intl";
import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import InputError from "./InputError";
import InputTitle from "./InputTitle";
import { uploadImage } from "api/upload";
import { handleImage } from "helpers/functions";
import { Context } from "components/Form";

const ImageUpload = ({
  name,
  langId = name,
  rules = { required: <FormattedMessage id="requiredField" /> },
  lg = 12,
  classNames = "",
}) => {
  const { control, errors } = useContext(Context);
  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const data = await uploadImage(e.target.files[0]);
      return data?.data?.files?.[0]?.path;
    }
  };
  return (
    <Col lg={lg}>
      <div className={`form-group mb-0 ${rules?.required ? "required" : ""}`}>
        {langId !== " " && <InputTitle name={langId} />}
        <div className={`image-uploader image-contain ${classNames}`}>
          <Controller
            control={control}
            render={({ field: { onChange, value, ref } }) => {
              return (
                <>
                  <div className="img-pat">
                    <img src={imageUpload} width={46} height={46} alt="" />
                  </div>
                  <label>
                    {value && (
                      <div>
                        <img
                          ref={ref}
                          src={value ? handleImage(value) : imageUpload}
                          width={160}
                          height={160}
                          alt=""
                        />
                        <button
                          className="removeImg"
                          onClick={() => {
                            // empty image value
                            onChange("");
                          }}
                        >
                          <img src={removeImg} alt="" />
                        </button>
                      </div>
                    )}
                    <input
                      accept="image/*"
                      type="file"
                      onChange={async (e) => {
                        let path = await imageChange(e);
                        onChange(path);
                      }}
                    />
                  </label>
                </>
              );
            }}
            name={name}
            rules={rules}
          />

          <InputError name={name} errors={errors} />
        </div>
      </div>
    </Col>
  );
};

export default ImageUpload;
